import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Target, Eye, Heart, Award } from 'lucide-react';

const AboutUs = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'hsl(30, 30%, 98%)' }}>
      <Navigation />

      {/* Hero Section */}
      <section className="relative py-12 sm:py-16 lg:py-20">
        <div className="absolute inset-0 overflow-hidden" style={{ backgroundColor: '#1e3a8a' }}>
          <img
            src="https://storage.googleapis.com/fenado-ai-farm-public/generated/cf54d958-40df-4795-9ee8-b5f57d14a190.webp"
            alt="Moonlit Sky"
            className="w-full h-full object-cover opacity-60"
          />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: '#ffffff', lineHeight: 1.4 }}>
            About Us
          </h1>
          <p className="text-base sm:text-lg lg:text-xl leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: '#ffffff', lineHeight: 1.7 }}>
            Building a legacy with passion and integrity by providing beneficial, innovative, high-quality, great value products within India that will be for the masses.
          </p>
        </div>
      </section>

      {/* Purpose Statement */}
      <section className="py-8 sm:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 lg:p-12">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
              Purpose Statement
            </h2>
            <p className="text-base sm:text-lg leading-relaxed mb-6" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
              An in-depth understanding of the Indian consumer need and psyche has helped us develop a marketing philosophy that reflects the needs of the Indian masses. We aim to make a tradition to deliver both glow and benefits to our Indian women, with a value-for-money positioning that allows people from all classes and age groups to enjoy Moonlit Daily Beauty Cream to the fullest.
            </p>
            <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
              We aim to build a reach spanning the remotest villages of India and across its major cities, for which we would love to connect with strong leaders who wish to develop themselves in their business (kindly contact us).
            </p>
          </div>
        </div>
      </section>

      {/* Vision and Mission */}
      <section className="py-8 sm:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
            {/* Vision */}
            <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8">
              <h2 className="text-2xl sm:text-3xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
                Our Vision
              </h2>
              <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                Our vision is to reach masses and become their most preferred Daily Beauty cream with beneficial ingredients and quality product.
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8">
              <h2 className="text-2xl sm:text-3xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
                Our Mission
              </h2>
              <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                Our mission is to bring a change in Indian Skin Habits by providing them the Skin Cream that heals them and allowing them to Glow daily. We strive to make a Quality product with our unique ingredients and formulation bringing together for the very first time a product that not just gives them glow but benefits their skin too.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ethics */}
      <section className="py-8 sm:py-12 pb-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 lg:p-12">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
              Our Ethics
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: 'hsl(345, 60%, 60%)' }}></div>
                <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                  Honesty & Integrity
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: 'hsl(345, 60%, 60%)' }}></div>
                <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                  Treat every Employee with honour/dignity
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: 'hsl(345, 60%, 60%)' }}></div>
                <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                  Diligence & Perfection, even though it's unreachable— we must do our best to get close to it – Leaving no room for laziness
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;
